@defer (on viewport; hydrate on immediate) {
	@for (blok of carouselInputs(); track $index) {
		@if (components) {
			<ndc-dynamic
				[ndcDynamicComponent]="components[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
	@if (hotelData(); as hotel) {
		<section class="section-spacing bg-white">
			<div class="section-inner section-gap flex-col">
				<div class="column-gap flex-col lg:flex-row">
					@let address = hotel.address;
					@let contact = hotel.contact;
					<div class="flex-col lg:w-2/3">
						@for (blok of title(); track $index) {
							<ndc-dynamic
								[ndcDynamicComponent]="
									components[blok['component']]
								"
								[ndcDynamicInputs]="blok"
								class="hidden"
							/>
						}
						@for (blok of content(); track $index) {
							<div data-test-id="mini-hotel-description">
								<ndc-dynamic
									[ndcDynamicComponent]="
										components[blok['component']]
									"
									[ndcDynamicInputs]="blok"
									class="hidden"
								/>
							</div>
						}
						@for (blok of usps(); track $index) {
							<ndc-dynamic
								[ndcDynamicComponent]="
									components[blok['component']]
								"
								[ndcDynamicInputs]="blok"
								class="hidden"
							/>
						}
						@if (hotel) {
							<h2
								class="running-head running-head-center"
								data-test-class="hotel-header"
							>
								{{
									'storyblok.pages.hotel-information'
										| translate
								}}
							</h2>
							@if (hotel.images?.length > 0) {
								<vp-mini-carousel
									[items]="hotelImages()"
									aspectRatio="21:9"
								/>
							}
							<vp-tab-menu
								color="white"
								data-test-id="hotel-info"
							>
								<vp-tab-menu-item
									[content]="facilitiesRef"
									[label]="'global.facilities' | translate"
									name="facilities"
								/>
								<vp-tab-menu-item
									[content]="goodToKnowsRef"
									[label]="'global.good-to-know' | translate"
									name="good-to-knows"
								/>
								@if (address.latitude && address.longitude) {
									<vp-tab-menu-item
										[content]="mapRef"
										[label]="'global.map' | translate"
										name="map"
									/>
								}
							</vp-tab-menu>
							<ng-template #facilitiesRef>
								<vp-list-grid
									[listItems]="hotel.facilities || []"
									[name]="'hotel-facilities'"
									[sheetTitle]="
										('global.hotel.label' | translate) +
										' ' +
										('global.facilities' | translate)
									"
									[useCol2]="true"
								/>
							</ng-template>
							<ng-template #goodToKnowsRef>
								<vp-list-grid
									[listItems]="hotel.goodToKnows || []"
									[name]="'hotel-good-to-knows'"
									[sheetTitle]="
										'global.good-to-know' | translate
									"
									[useCol2]="false"
								/>
							</ng-template>
							<ng-template #mapRef>
								<vp-map
									[lat]="address.latitude"
									[long]="address.longitude"
								/>
							</ng-template>
						}
					</div>
					<div class="flex-col lg:w-1/3">
						<vp-persuade-card
							[ctaText]="'global.contact-card-cta' | translate"
							[ctaType]="'btn-secondary'"
							[ctaUrl]="hotel.toUrl"
							[title]="'global.contact-card-title' | translate"
							[useVerticalCard]="true"
							data-test-id="cta-card"
						>
							<ng-container content>
								{{ address.street }}
								{{ address.streetNumber }}
								{{ address.streetNumberAddition }}<br />
								{{ address.postalCode }}
								{{ address.city }}<br />
								@if (contact.phone; as phone) {
									<a
										[href]="'tel:' + phone"
										class="text-link"
										data-test-id="contact-phone"
									>
										{{ phone }}
									</a>
									<br />
								}
								@if (contact.email; as email) {
									<a
										[href]="'mailto:' + email"
										class="text-link"
										data-test-id="contact-email"
									>
										{{ email }}
									</a>
									<br />
								}
							</ng-container>
						</vp-persuade-card>
						@if (hotel.rating?.score) {
							<vp-rating
								[isHorizontal]="true"
								[numberOfRatings]="hotel.rating.numberOfRatings"
								[score]="hotel.rating.score"
							/>
						}
					</div>
				</div>
			</div>
		</section>
	}
} @placeholder {
	<vp-skeleton />
}
